import ThemeWrapper from './ThemeWrapper';
export default ThemeWrapper;
